import { Box, Button, Grid } from "@mui/material";
import {
	DateRangePicker,
	SingleInputDateRangeField,
} from "@mui/x-date-pickers-pro";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "moment/locale/es";
import { useTranslation } from "react-i18next";
import { getBorder } from "utils/Styles";
import { shortcuts } from "utils/Times";
//import { LoadingButton } from "@mui/lab"
import moment from "moment";

const ToolbarTotals = ({
	reloading,
	range,
	setRange,
	loadingResults,
	loadingAssingedPaycodes,
}) => {
	const { t } = useTranslation();

	return (
		<>
			<Box
				width={{ sm: "80%", md: "90%", lg: "100%" }}
				sx={{
					flexDirection: "row",
					justifyContent: "flex-start",
					alignItems: "center",
					gap: 2,
					p: 1.5,
					borderBottom: (theme) => getBorder(theme.palette.mode),
				}}
			>
				<Grid container spacing={2} direction={"row"}>
					<Grid size={{ sm: 2, md: 3, lg: 3 }}>
						<LocalizationProvider
							dateAdapter={AdapterMoment}
							adapterLocale={moment.locale()}
						>
							<DateRangePicker
								label={t("utils.filter.range_of_days")}
								slots={{ field: SingleInputDateRangeField }}
								slotProps={{
									shortcuts: {
										items: shortcuts(t),
									},
									textField: {
										size: "large",
									},
								}}
								//format={JSON.parse(sessionStorage.getItem('config'))?.date_format}
								calendars={1}
								fullwith
								onChange={(value) => {
									setRange(value);
								}}
								value={range}
								sx={{
									width: "100%",
								}}
							/>
						</LocalizationProvider>
					</Grid>

					<Grid size={{ sm: 6, md: 7, lg: 7 }} />

					<Grid size={{ sm: 2, md: 2, lg: 2 }}>
						<Button
							size="large"
							fullWidth
							sx={{ height: "100%" }}
							loading={loadingResults || loadingAssingedPaycodes}
							variant="contained"
							disabled={range[0] === null || range[1] === null}
							onClick={() => reloading()}
						>
							{t("utils.filter.search")}
						</Button>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};

export { ToolbarTotals };
